import axios from 'axios';
import { returnErrors } from './errorActions';
import { tokenConfig } from './authActions';
import {
  GET_QUESTIONS,
  GET_QUESTIONS_LIST,
  GET_QUESTIONS_MINIMAL,
  GET_QUESTION,
  ADD_QUESTION,
  DELETE_QUESTION,
  UPDATE_QUESTION,
  QUESTIONS_LOADING,
  QUESTION_LOADING,
  CLEAR_CURRENT_QUESTION,
  SET_QUESTIONS_PAGE
} from './types';

// Get lightweight questions list with pagination and filtering (for table display)
export const getQuestionsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setQuestionsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.question && filters.question.length > 0) {
    const encodedQuestions = filters.question.map(text => encodeURIComponent(text));
    queryParams += `&question=${encodedQuestions.join(',')}`;
  }
  if (filters.tags && filters.tags.length > 0) {
    const encodedTags = filters.tags.map(tag => encodeURIComponent(tag));
    queryParams += `&tags=${encodedTags.join(',')}`;
  }

  axios
    .get(`/api/questions/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_QUESTIONS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single question by ID (for view/edit pages)
export const getQuestion = (id) => (dispatch, getState) => {
  dispatch(setQuestionLoading());
  axios
    .get(`/api/questions/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_QUESTION, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current question
export const clearCurrentQuestion = () => {
  return { type: CLEAR_CURRENT_QUESTION };
};

// Get minimal questions list (for dropdowns/selectors - returns only _id and text)
export const getQuestionsMinimal = () => (dispatch, getState) => {
  dispatch(setQuestionsLoading());
  axios
    .get('/api/questions/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_QUESTIONS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// DEPRECATED: Use getQuestionsList() instead
export const getQuestions = () => (dispatch, getState) => {
  dispatch(setQuestionsLoading());

  axios
    .get('/api/questions', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_QUESTIONS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

// Get Questions by Program
export const getQuestionsByProgram = (programId) => (dispatch, getState) => {
  dispatch(setQuestionsLoading());

  axios
    .get(`/api/questions/program/${programId}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_QUESTIONS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

// Add Question
export const addQuestion = (question) => (dispatch, getState) => {
  return axios
    .post('/api/questions', question, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_QUESTION,
        payload: res.data
      });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

// Update Question
export const updateQuestion = (id, question) => (dispatch, getState) => {
  return axios
    .put(`/api/questions/${id}`, question, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_QUESTION,
        payload: res.data
      });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

// Delete Question
export const deleteQuestion = (id) => (dispatch, getState) => {
  axios
    .delete(`/api/questions/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_QUESTION,
        payload: id
      })
    )
    .catch(err =>
      dispatch(returnErrors(err.response.data, err.response.status))
    );
};

export const setQuestionsLoading = () => {
  return {
    type: QUESTIONS_LOADING
  };
};

export const setQuestionLoading = () => {
  return { type: QUESTION_LOADING };
};

// Set current page number (without fetching data)
export const setQuestionsPage = (page) => {
  return { type: SET_QUESTIONS_PAGE, payload: page };
};
